import { joinURL } from "ufo";
import { Client, Enumerable, ResourceId } from "../types/internal";
import { omitData } from "../utils/data";
import { Event, EventMap } from "../models/Event";
import { EventAvailability, QueryOptions } from "../models";

export const createEvent = (client: Client) => ({
  retrieve: (id: ResourceId, fields?: Enumerable<string>) => {
    return client.retrieve<Event>(["events", id], fields).then((result) => ({
      ...omitData(result),
      event: result.data,
    }));
  },
  list: (options?: QueryOptions) => {
    return client.list<Event[]>("events", options).then((result) => ({
      ...omitData(result),
      events: result.data,
    }));
  },
  availability: (id: ResourceId) => {
    return client.availability<EventAvailability>("events", id);
  },
  map: async <E>(occurrenceId: number) => {
    const url = joinURL("events/map", String(occurrenceId));
    return client.get<EventMap<E>>(url);
  },
});
